import React, { ChangeEvent, useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue, IInputData } from '../../../interface/steps.interface'
import { useStore } from '../../../module/rootStore'
import {
  substituteLink,
  TextPart,
  TextPartTypes,
} from '../../../lib/substitute/substituteLink'
import ToIcon from '../../../assets/icon.svg'

import styles from './Checkbox.module.scss'

interface Props {
  value: string
  name: string
  status: IInputStatus
  handleChange: IChangeValue
  settings: IInputData
}

export const Checkbox = ({
  value,
  status,
  handleChange,
  name,
  settings,
}: Props) => {
  const { label, emptyErrorText } = settings
  const id = uuidv4()
  const { replacements } = useStore().StepsStore

  const [localLabel, setLocalLabel] = useState<TextPart[]>([])

  const handler = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = !value || value === '0' ? '1' : '0'
    handleChange(name, newValue, false)
  }

  useEffect(() => {
    const modLabel = substituteLink(label, replacements)
    setLocalLabel(modLabel)
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.check_wrapper}>
          <div className={styles.check_input}>
            <input
              className={styles.checkbox}
              type="checkbox"
              id={id}
              onChange={handler}
              defaultChecked={value === '1' ? true : false}
            />
            <label className={styles.label} htmlFor={id}>
              {/* {label} */}
              Acepto las condiciones de uso y política de privacidad
            </label>

          </div>
          {status === IInputStatus.error && (
            <div className={styles.error}>{emptyErrorText}</div>
          )}
        </div>

        <div className={styles.policy}>
          <span>
            <a
              className={styles.link}
              href={'/condiciones-de-uso'}
              target="_blank"
              rel="noreferrer"
            >
              Condiciones de uso
              <img src={ToIcon} />
            </a>
          </span>
          <span>
            <a
              className={styles.link}
              href={'/politica-de-privacidad'}
              target="_blank"
              rel="noreferrer"
            >
              Política de privacidad
              <img src={ToIcon} />
            </a>
          </span>
        </div>
      </div>

    </div>
  )
}
